export default __webpack_public_path__ + "static/request-review-09b48478ef382145b735076c55612777.png";